import { render, staticRenderFns } from "./r-world-region-page.vue?vue&type=template&id=5775df8d"
import script from "./r-world-region-page.vue?vue&type=script&lang=js"
export * from "./r-world-region-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5775df8d')) {
      api.createRecord('5775df8d', component.options)
    } else {
      api.reload('5775df8d', component.options)
    }
    module.hot.accept("./r-world-region-page.vue?vue&type=template&id=5775df8d", function () {
      api.rerender('5775df8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/world-region/r-world-region-page.vue"
export default component.exports